import React from "react";
import ApplicationProvider from "pages/application-provider";
import {
  Button,
  Flex,
  Text,
  rem,
  SimpleGrid,
  Title,
  Box,
} from "@mantine/core";
import '@mantine/carousel/styles.css';
import CarouselOp from "components/login/CarouselOp";

interface Props {
  loginUrl: string;
  staticBaseUrl: string;
}

export default function LogoutPage({ loginUrl, staticBaseUrl }: Props) {
  return (
    <ApplicationProvider>
      <Flex direction="column" w="100svw" h="100svh" p={rem(16)}>
        <SimpleGrid cols={2} h="100%">
          <Flex direction="column" p={rem(40)}>
            <Box maw={rem(262)} flex={1} component="a" href="/">
              <img src={`${staticBaseUrl}alone/images/logo-big.svg`} alt="Alone" />
            </Box>

            <Flex direction="column" gap={rem(24)} mb={rem(120)}>
              <Title fw={600} fz={rem(32)} lh={rem(40)} c="#171717">
                You’ve been <span style={{ color: "#E20914" }}>logged out</span>
              </Title>
              <Text fz={rem(18)} lh={rem(28)} c="dimmed">
                Thanks for using the platform. You can log in again anytime below.
              </Text>

              <Button
                variant="filled"
                bg="#4B49AC"
                p={rem(16)}
                style={{ borderRadius: "12px" }}
                h={rem(56)}
                w="100%"
                mt={rem(24)}
                component="a"
                href={loginUrl}
              >
                <Text c="#FFFFFF" fz={rem(16)} lh={rem(24)} fw={500}>
                  Back to Login
                </Text>
              </Button>
            </Flex>
          </Flex>

          <CarouselOp staticBaseUrl={staticBaseUrl}/>
        </SimpleGrid>
      </Flex>
    </ApplicationProvider>
  );
}